import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LivechatStatusComponent } from './components/livechat-status/livechat-status.component';
// import { CommonFeaturesModule } from './common-features/common-features.module';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { AudiorecordingService } from './services/audio-recording/audiorecording.service';
import { ChatqueueService } from './services/chatqueue/chatqueue.service';
import { CommunicationInterfaceService } from './services/communicationInterface/communication-interface.service';
import { FileTransferService } from './services/file-transfer/file-transfer.service';
import { LivechatStartService } from './services/livechat-start/livechat-start.service';
import { MessengerService } from './services/messenger/messenger.service';
import { WebsocketService } from './services/websockets/websocket.service';
import { SharedModule } from './shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    ThankYouComponent,
    LivechatStatusComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    DragDropModule,
    HttpClientModule,
    // CommonFeaturesModule,
    CommonModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerImmediately'
    }),
    MatSelectModule
  ],
  providers: [    
    // FormGroupDirective
    CommunicationInterfaceService,
    LivechatStartService,
    ChatqueueService,
    MessengerService,
    FileTransferService,
    WebsocketService,
    AudiorecordingService,
  ],
  bootstrap: [AppComponent]  
})
export class AppModule {}
